import gql from 'graphql-tag';
import { auth0UserFieldsFragment } from '@graphql/admin/fragments';

export const updateUserMutation = gql`
  mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      ...AdminAuth0UserFields
    }
  }

  ${auth0UserFieldsFragment}
`;